import { Button } from '@lokalise/louis'
import type { StaticProfileConfig } from '@lokalise/translation-api-schemas'
import { useState } from 'react'
import { AI_PROFILES_DOCUMENTATION_URL } from '../../../constants/url'
import { BaseProfileModal } from '../../BaseProfileModal/BaseProfileModal'
import { CardContainer } from '../components/CardContainer/CardContainer'
import { CardModel } from '../components/CardModel/CardModel'
import { CardTitle } from '../components/CardTitle/CardTitle'
import { ProjectTag } from '../components/ProjectTag/ProjectTag'
import styles from './ProfileCardStatic.module.css'

type ProfileCardStaticProps = {
  profile: StaticProfileConfig
  showEdit?: boolean
}

export const ProfileCardStatic = ({ profile, showEdit }: ProfileCardStaticProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <CardContainer>
      <div className="flex justify-between">
        <div className="flex-col gap-3">
          <div className="flex gap-2">
            <ProjectTag type="default" />
            <ProjectTag type="active" />
            <CardModel integration={profile.config.integration} />
          </div>
          <CardTitle title="Base AI profile" />
        </div>
        {showEdit && (
          <Button
            type="button"
            variant="tertiary"
            size="sm"
            onClick={() => setIsModalOpen((open) => !open)}
          >
            Edit
          </Button>
        )}
        {isModalOpen && (
          <BaseProfileModal onClose={() => setIsModalOpen(false)} profile={profile} />
        )}
      </div>
      <div className={styles.bodyText}>
        <p>
          This is your Pro AI that runs automatically in your projects for AI suggestions, AI tasks,
          and AI automations – using standard context like Glossary and Style Guide. For higher
          translation quality create custom AI profiles.{' '}
          <a href={AI_PROFILES_DOCUMENTATION_URL} rel="noopener noreferrer" target="_blank">
            Learn more
          </a>
        </p>
      </div>
    </CardContainer>
  )
}
